import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=03c62f7a&scoped=true&"
import script from "./Labels.vue?vue&type=script&lang=js&"
export * from "./Labels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c62f7a",
  null
  
)

export default component.exports